<template>
  <v-footer
    padless
    style="padding-top: 10px;"
  >
    <v-card-text class="pt-0 text-center">
      <p>画像等の著作権は桃鳥さんにあり、アプリの著作権はいらにかにあります。アプリに関するお問い合わせは<a href="https://twitter.com/happy_packet">いらにか(twitter)</a>までお願いします。</p>
      <p>もしこのアプリを気に入って支援したい人がいたら<a href="https://www.amazon.co.jp/hz/wishlist/genericItemsPage">いらにかの欲しいものリスト</a>でプレゼントを送ってあげてください。コーヒーとか喜びます。</p>
    </v-card-text>
      
    <v-divider></v-divider>

    <v-card-text class="text-center">
      みちくさびゅーあー ©2019 iranika(@happy_packet)
    </v-card-text>
  </v-footer>
</template>

<script>
export default {

}
</script>

<style>

</style>